import { buildLaunchSetup, launchSetupStepsHtml, wireLaunchSetup } from './farm-modals';
import { buildVmosSetup, vmosSetupHtml, wireVmosSetup } from './farm-vmos-setup';
import { buildWindowsSetup, windowsSetupHtml, wireWindowsSetup } from './farm-windows-setup';
import { buildMacSetup, macSetupHtml, wireMacSetup } from './farm-mac-setup';
import { t } from '../ui/lang';
/**
 * Renders the Launch / Setup body (Linux + Windows + macOS + VMOS device sub-tabs) into
 * `host`, including the sub-tab switcher. Shared by the unified farm-settings "Setup"
 * tab (host branch of {@link renderSetupTab}) and the post-create modal
 * (`showLaunchConfigModal`). Default sub-tab is Linux.
 */
export function renderLaunchSetupBody(host, name, key) {
    const std = buildLaunchSetup(name, key);
    const win = buildWindowsSetup(name, std);
    const mac = buildMacSetup(name, key, std);
    const vmos = buildVmosSetup(name, key);
    host.innerHTML = `
        <div class="launch-subtabs" role="tablist">
            <button type="button" class="launch-subtab active" data-subtab="standard">${t('farms.subtab_linux')}</button>
            <button type="button" class="launch-subtab" data-subtab="windows">${t('farms.subtab_windows')}</button>
            <button type="button" class="launch-subtab" data-subtab="mac">${t('farms.subtab_mac')}</button>
            <button type="button" class="launch-subtab" data-subtab="vmos">${t('farms.subtab_vmos')}</button>
        </div>
        <div class="launch-subpanel" data-subpanel="standard">${launchSetupStepsHtml(std)}</div>
        <div class="launch-subpanel" data-subpanel="windows" style="display:none">${windowsSetupHtml(win)}</div>
        <div class="launch-subpanel" data-subpanel="mac" style="display:none">${macSetupHtml(mac)}</div>
        <div class="launch-subpanel" data-subpanel="vmos" style="display:none">${vmosSetupHtml(vmos)}</div>
    `;
    const standardPanel = host.querySelector('[data-subpanel="standard"]');
    const windowsPanel = host.querySelector('[data-subpanel="windows"]');
    const macPanel = host.querySelector('[data-subpanel="mac"]');
    const vmosPanel = host.querySelector('[data-subpanel="vmos"]');
    wireLaunchSetup(standardPanel, std, name);
    wireWindowsSetup(windowsPanel, win, name);
    wireMacSetup(macPanel, mac, name);
    wireVmosSetup(vmosPanel, vmos, name);
    const tabs = Array.from(host.querySelectorAll('.launch-subtab'));
    const panels = Array.from(host.querySelectorAll('.launch-subpanel'));
    tabs.forEach((t) => t.addEventListener('click', () => {
        const key = t.dataset['subtab'];
        tabs.forEach((b) => b.classList.toggle('active', b.dataset['subtab'] === key));
        panels.forEach((p) => { p.style.display = p.dataset['subpanel'] === key ? '' : 'none'; });
    }));
}
